<template>
  <v-flex>
    <v-data-table :headers="headers" :loading="loadingState" :items="gnipRules" hide-actions class="elevation-1" item-key="tag + '-' + value">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">
          <router-link v-if="$store.getters.getProjectByUuid(props.item.tag)" :to="/projects/ + $store.getters.getProjectByUuid(props.item.tag).id">
            {{ $store.getters.getProjectByUuid(props.item.tag).id }}
          </router-link>
        </td>
        <td class="text-xs-left">{{ props.item.tag }}</td>
        <td class="text-xs-left">{{ props.item.value }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click.native="deleteItem(props.item.tag, props.item.value);"><v-icon>delete</v-icon></v-btn>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning" outline>No data available</v-alert>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      loadingState: false,
      headers: [
      { text: 'Project ID', align: 'left', value: 'projectId' },
      { text: 'Tag', align: 'left', value: 'tag' },
      { text: 'Rule', align: 'left', value: 'rule' },
      { text: '', align: 'left', value: 'actions', sortable: false } ]
    }
  },
  computed: {
    ...mapGetters({
      gnipRules: 'getGNIPRules',
      projects: 'getProjects'
    })
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('loading', ['showLoading', 'hideLoading']),
    ...mapActions({deleteGNIPRule: 'deleteGNIPRule'}),
    getData () {
      this.loadingState = true
      axios.all([this.$store.dispatch('getProjects'), this.$store.dispatch('getGNIPRules')]).then(axios.spread((projectsResponse, gnipRulesResponse) => {
        if (projectsResponse.data.status === 'SUCCESS') this.$store.commit('setProjects', projectsResponse.data.payload)
        if (gnipRulesResponse.data.status === 'SUCCESS') this.$store.commit('setGNIPRules', gnipRulesResponse.data.payload)
        this.loadingState = false
      })).catch((err) => {
        this.loadingState = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    deleteItem (tag, value) {
      this.$vuetifyConfirmDialog.open('', 'Are you sure you want to delete this rule?', 'Cancel', 'Delete').then(state => {
        if (state) {
          this.loadingState = true
          axios.all([this.$store.dispatch('deleteGNIPRule', {tag: tag, value: value})]).then(axios.spread((gnipRulesResponse) => {
            this.loadingState = false
            this.$store.commit('deleteGNIPRule', gnipRulesResponse.data.payload)
          })).catch((err) => {
            this.loadingState = false
            console.log(err)
          })
        }
      })
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gnipRules/GnipRulesTable.vue